export default __webpack_public_path__ + "static/media/Montserrat-Regular.a04b5e24.woff";